import 'whatwg-fetch';
const env = process.env;

const getUserData = (payload) => {
	return fetch(`${env.VUE_APP_trimaster}/api/v1/users/${payload.id}?access_token=${payload.apitoken}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json'
		}
	})
}

export default {
	getUserData
}
